"use client";
import { j as e } from "./index.es9.js";
import { forwardRef as c } from "react";
import { composeClassNames as b } from "./index.es88.js";
import n from "./index.es89.js";
c(
  ({
    label: s,
    type: i = "text",
    value: r,
    placeholder: t,
    onChange: o,
    state: l,
    message: a,
    isDisabled: m,
    ...p
  }, d) => /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs("label", { className: "bl-size-6 bl-display-block", children: [
    s,
    /* @__PURE__ */ e.jsx(
      "input",
      {
        ...p,
        ref: d,
        className: b(
          "bl-input",
          l && `bl-input--${l}`,
          "bl-m-t-1"
        ),
        onChange: o,
        type: i,
        value: r,
        disabled: m,
        placeholder: t
      }
    ),
    a && /* @__PURE__ */ e.jsx("div", { className: "bl-p-t-1", children: /* @__PURE__ */ e.jsx(n, { state: l, children: a }) })
  ] }) })
);
//# sourceMappingURL=index.es12.js.map
